module.exports = require("core-js-pure/stable/object/assign");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/object/assign.js
// module id = 153
// module chunks = 0 1